"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSockets = void 0;
const constants_1 = require("../constants");
class WebSockets {
    constructor(url, protocols, transformDataFn) {
        this.isConnetionOpen = false;
        this.eventsCallback = {
            onError: (_error) => null,
            onReceiveData: (_data) => null,
        };
        this.url = url;
        this.protocols = protocols;
        this.transformDataFn = transformDataFn || ((data) => data);
    }
    notifyConnect() {
        var _a, _b;
        (_b = (_a = this.eventsCallback) === null || _a === void 0 ? void 0 : _a.onConnect) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    notifyDisconnect() {
        var _a, _b;
        (_b = (_a = this.eventsCallback) === null || _a === void 0 ? void 0 : _a.onDisconnect) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    notifyReceiveData(data) {
        this.eventsCallback.onReceiveData(data);
    }
    notifyError(error) {
        this.eventsCallback.onError(error);
    }
    connect() {
        return new Promise((resolve, reject) => {
            if (!this.isConnetionOpen) {
                try {
                    this.websocket = new WebSocket(this.url, this.protocols);
                    this.websocket.onopen = () => {
                        var _a;
                        if (((_a = this.websocket) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.OPEN) {
                            this.isConnetionOpen = true;
                            this.notifyConnect();
                            resolve();
                        }
                    };
                    this.websocket.onmessage = event => {
                        this.notifyReceiveData(this.transformDataFn(event.data));
                    };
                    this.websocket.onerror = error => {
                        this.notifyError(new Error(error.toString()));
                    };
                }
                catch (error) {
                    reject(error);
                }
            }
            else {
                reject(new Error(constants_1.ERROR_MESSAGES_WEBSOCKETS.CONNECTION_ALREADY_OPEN));
            }
        });
    }
    disconnect() {
        return new Promise((resolve, reject) => {
            var _a;
            if (this.isConnetionOpen) {
                try {
                    (_a = this.websocket) === null || _a === void 0 ? void 0 : _a.close();
                    this.isConnetionOpen = false;
                    this.notifyDisconnect();
                    resolve();
                }
                catch (error) {
                    reject(error);
                }
            }
            else {
                reject(new Error(constants_1.ERROR_MESSAGES_WEBSOCKETS.CONNECTION_ALREADY_CLOSED));
            }
        });
    }
    send(data) {
        var _a;
        if (this.isConnetionOpen) {
            (_a = this.websocket) === null || _a === void 0 ? void 0 : _a.send(data);
        }
        else {
            this.notifyError(new Error(constants_1.ERROR_MESSAGES_WEBSOCKETS.CONNECTION_NOT_OPEN));
        }
    }
    listen(eventsCallback) {
        this.eventsCallback = Object.assign(Object.assign({}, this.eventsCallback), eventsCallback);
    }
}
exports.WebSockets = WebSockets;
//# sourceMappingURL=index.js.map